import dayjs, { Dayjs } from 'dayjs';

import CustomDatePicker from 'components/CustomDatePicker';

interface IMonthPickerProps {
  startDate: Dayjs;
  endDate?: Dayjs;
  label: string;
  name: string;
  setValue: (value: Dayjs | null) => void;
  value: Dayjs;
  error?: boolean;
}

const MonthPicker: React.FC<IMonthPickerProps> = ({
  startDate,
  endDate,
  label,
  name,
  setValue,
  value,
  error,
}) => {
  const parsedValue = dayjs(value);

  return (
    <CustomDatePicker
      name={name}
      format="MM/YYYY"
      label={label}
      views={['year', 'month']}
      minDate={startDate}
      maxDate={endDate}
      value={parsedValue.isValid() ? parsedValue : dayjs()}
      setValue={setValue}
      error={error}
    />
  );
};

export default MonthPicker;
